module.exports = __webpack_public_path__ + "img/link-horizontal-slash.5b074ac0.svg";